// Sends an enquiry to Netlify Forms (used on the static Netlify build, where there is no backend).
// Netlify emails each submission to the addresses set under Site configuration > Notifications.
// Form names and field names must match the hidden skeleton forms in /public/forms.html.
const TITLES = { sourcing: "Sourcing enquiry", rnd: "R&D project enquiry", contact: "General enquiry" };

export const makeReference = () => `SPC-${Date.now().toString(36).toUpperCase().slice(-6)}`;

export const submitNetlifyForm = async (formType, fields, values, reference) => {
  const body = new URLSearchParams({
    "form-name": formType,
    subject: `SPC website: ${TITLES[formType] || "Enquiry"} ${reference}`,
    reference,
  });
  fields.forEach((f) => {
    const v = values[f.name];
    body.append(f.name, f.type === "checkbox" ? (v ? "Yes" : "No") : String(v ?? ""));
  });
  const res = await fetch("/forms.html", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  });
  if (!res.ok) throw new Error(`Form submission failed (${res.status})`);
};
